import React, { useState } from 'react';
import strings from 'strings';
import FPDrawer from 'UI/components/templates/FPDrawer/FPDrawer';
import TabsView from 'UI/components/templates/TabsView';

import { RoleplayCallInsights } from '../RoleplayCallInsights';
import { RoleplayCallTranscript } from '../RoleplayCallTranscript';

const COPIES = strings.ai.generators.roleplay.feedbackDrawer;

export const RoleplayFeedbackDrawer = ({ callId = null, onClose = () => {} }) => {
  const [activeTab, setActiveTab] = useState(0);

  const tabsProp = [
    {
      label: COPIES.tabs.aiInsights.title,
      view: <RoleplayCallInsights callId={callId} />
    },
    {
      label: COPIES.tabs.transcript.title,
      view: <RoleplayCallTranscript callId={callId} />
    }
  ];

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <FPDrawer
      CardHeaderProps={{ title: COPIES.title }}
      FPDrawerProps={{
        open: true,
        onClose
      }}
      hasPaddingContent={false}
      onClose={onClose}
    >
      <TabsView
        onChangeTabIndex={handleTabChange}
        selectedTab={activeTab}
        tabs={tabsProp}
        tabsContainerProps={{ scrollButtons: 'off' }}
      />
    </FPDrawer>
  );
};
